export const MASTERS_ACCESS = ['tender.masters.manage', 'masters.view'];

export const SETTINGS_ACCESS = [
  'platform.users.manage',
  'platform.roles.manage',
  'platform.company.manage',
  'platform.ai.configure',
  'tender.masters.manage',
  'users.view',
  'roles.view',
  'company.view',
  'ai.view',
  'masters.view'
];

export const TIMESHEET_ACCESS = [
  'tender.timesheet.submit',
  'tender.timesheet.approve',
  'tender.timesheet.reopen',
  'tender.reports.read',
  'timesheets.view'
];

export const APPROVAL_ACCESS = [
  'tender.decision.approve',
  'tender.response.review',
  'tender.costing.approve',
  'tender.timesheet.approve',
  'tender.eligibility.edit',
  'decisions.update',
  'responses.approve',
  'costing.approve',
  'timesheets.approve',
  'eligibility.update'
];

export const KNOWLEDGE_ACCESS = ['tender.documents.read', 'tender.read', 'knowledge.view'];
export const REGISTER_ACCESS = ['tender.read', 'tender.create', 'tenders.view'];
export const SECURITIES_ACCESS = ['tender.read', 'tender.reports.read', 'securities.view'];
